const E = {
  PaymentSummary: 'Payment Summary',
  BillTo: 'Bill To:', 
  PrepaidRequest: 'PREPAID REQUEST #: {{requestNumber}}',
  PayNow: 'Pay Now',
  SendPaymentLink: 'Send Payment Link',
  TestPackageName: 'Test/Package Name',
  Unit: 'Units',
  Price: 'Price',
  Total: 'Total',
  Matrix:'Matrix',
  SubTotal: 'Sub Total',
  Tax: 'Tax', 
  CustomerDetails:'CUSTOMER DETAILS',
  CardHolderName: 'Card Holder Name',
  PaymentDetails: 'PAYMENT DETAILS',
  TransactionAmount: 'Transaction Amount',
  OrderID: 'Order ID',
  CardNo: 'Card Number',
  ExpirtyDate: 'Expiry Date (MM/YY)',
  CVD: 'CVD',
  CancelTransaction:'Cancel Transaction',
  ProcessTransaction:'Process Transaction',
  IUnderstand:'I understand:',
  CHKLbl3:'No changes shall be made to the analytical request after payment is received. Any additional analytical requirements must be requested on a new submission.',
  CHKLbl1:'Payments referred to herein shall not be refundable under any circumstances, including but not limited to the termination of the Agreement for whatever reason.',
  CHKLbl2:'Bureau Veritas is not responsible for delays in shipping that impact sample integrity.',
  MsgBox2:'Please complete the following details exactly as they appear on your card. Do not put spaces or hyphens in the card number.',
  MsgBox3:'Click Process Transaction to charge your card. Only click the button once. Using the Back, Refresh, or Cancel buttons after you press the Process Transaction button will not stop the transaction from being processed and may result in a double charge.',

  InvoiceAttention: 'Invoice Attention',
  ClientCompany: 'Client Company',   
  TotalCAD: 'Total (CAD)',
  Payment: 'Payment',
  Facility:'Facility',
  Street1:'Street 1',
  Street2:'Street 2',
  CityProvince:'City, Province',
  Postal:'Postal',
  Country:'Country',
  MissingContactEmail: 'Contact email is required.',
  ReceiptAlreadyUsed:'Selected Receipt already used.',
};

const F = {
  PaymentSummary: 'Résumé de paiement',
  BillTo: 'Facturer à:', 
  PrepaidRequest: 'NO DE DEMANDE PRÉPAYÉ: {{REQUESTNUMBER}}',
  PayNow: 'Payez maintenant',
  SendPaymentLink: 'Envoyer le lien de paiement',
  TestPackageName: 'Nom du groupe/analyse',
  Unit: 'Unités',
  Matrix: 'Matrice',
  Price: 'Prix',
  Total: 'Total',
  SubTotal: 'Sous-total',
  Tax: 'Taxe', 
  CustomerDetails:'Information sur le client',
  CardHolderName: 'Détenteur de la carte',
  PaymentDetails: 'Détails du paiement',
  TransactionAmount: 'Montant de la transaction',
  OrderID: 'No de commande',
  CardNo: 'No de la carte',
  ExpirtyDate: 'Date d expiration (MM AA)',
  CVD: 'CVV',
  CancelTransaction:'Annuler la transaction',
  ProcessTransaction:'Traiter la transaction',
  IUnderstand:'Je comprends:',
  CHKLbl3:'Aucune modification ne sera apportée à la demande d`analyse après réception du paiement. Toute exigence analytique supplémentaire doit être demandée sur une nouvelle demande.',
  CHKLbl1:'Les paiements mentionnés dans les présentes ne seront en aucun cas remboursables, y compris, mais sans s`y limiter, en cas de résiliation du Contrat pour quelque raison que ce soit.',
  CHKLbl2:'Bureau Veritas n`est pas responsable des retards d`expédition ayant un impact sur l`intégrité des échantillons.',
  MsgBox2:'Inscrire les renseignements suivants tels qu`indiqués sur votre carte. Entrez le numéro sans espace et trait d`union.',
  MsgBox3:'Cliquez sur Traiter la transaction pour débiter votre carte. Cliquez sur le bouton qu`une seule fois. La transaction sera effectuée même si vous cliquez sur Retour, Rafraîchir ou Annuler et pourrait même être traitée en double',

  InvoiceAttention: 'Destinaire',
  ClientCompany: 'Nom de l’entreprise',   
  TotalCAD: 'Total (CAD)',
  Payment: 'Paiement',
  Facility:'Succursale',
  Street1:'Adresse 1',
  Street2:'Adresse 2',
  CityProvince:'Ville, Province',
  Postal:'Code postal',
  Country:'Pays',
  MissingContactEmail: 'l’E-mail de contact est requis',
  ReceiptAlreadyUsed: 'Reçu sélectionné déjà utilisé.',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsPayment.js